import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import env from 'src/env';

class TelemetryService {
  constructor () {
    this.reactPlugin = new ReactPlugin();
  }

  initialize (reactPluginConfig) {
    const INSTRUMENTATION_KEY = env.AI_INSTRUMENTATION_KEY; // Enter your instrumentation key here

    this.appInsights = new ApplicationInsights({
      config: {
        enableAutoRouteTracking: true,
        disableTelemetry: process.env.NODE_ENV === 'development',
        instrumentationKey: INSTRUMENTATION_KEY,
        maxBatchInterval: 0,
        disableFetchTracking: false,
        extensions: [this.reactPlugin],
        extensionConfig: {
          [this.reactPlugin.identifier]: reactPluginConfig,
        },
      },
    });
    this.appInsights.loadAppInsights();
  }
}

export const ai = new TelemetryService();
